// Clientes que devem ser excluídos de TODAS as análises e telas do MINI Deck.
//
// Uso típico: pedido veio pro MINI Deck (via Bling ou cadastro manual)
// mas é de outra marca (ex: Arco Marcenaria — móveis planejados). Como
// não é gestão da Mini, precisa sumir de Pedidos, Logística, Kanban,
// Dashboards, RFM etc. sem apagar do Bling.
//
// Nomes ficam normalizados aqui (sem acento, minúsculo). O helper
// clienteExcluido() faz o match tolerante a acentos e caixa.

const NOMES_EXCLUIDOS = new Set([
  // Movéis planejados da Arco Marcenaria (fora do escopo da Mini)
  'natascha maria lisboa figueiredo',
])

// Normaliza igual a Set: minúsculo + sem acento + espaços consecutivos
function normNome(s) {
  return (s || '')
    .toString()
    .toLowerCase()
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
}

// True se o cliente do pedido está na lista de exclusão.
export function clienteExcluido(pedido) {
  const nome = normNome(pedido?.cliente?.nome)
  if (!nome) return false
  return NOMES_EXCLUIDOS.has(nome)
}
